<template>
    <div class="input-group">
        <input :type="showSymbols ? 'text' : 'password'"
               class="form-control"
               @input="onInput"
               :value="value"
               :id="id"
               :placeholder="placeholder">
        <div @click="showSymbols = !showSymbols" class="input-group-append">
            <span class="input-group-text clickable">
                <span v-show="showSymbols">
                    <i class="fal fa-eye-slash"></i>
                </span>
                <span v-show="!showSymbols">
                    <i class="fal fa-eye"></i>
                </span>
            </span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AppPasswordInput',
    props: {
        value: {
            type: String,
            default: ''
        },
        placeholder: {
            type: String,
            default: 'Password'
        },
        id: {
            type: String,
            default: 'password-input'
        }
    },
    data() {
        return {
            showSymbols: false
        }
    },
    model: {
        prop: 'value',
        event: 'input'
    },
    methods: {
        onInput(event) {
            this.$emit('input', event.target.value)
        }
    }
}
</script>
